import { Modal, MODAL_EVENT } from "./Modal";
import Label from "./Label";
import InputComponent from "./Input";

export { Label, MODAL_EVENT, InputComponent as Input };
export default Modal;
